// Copyright 2016 Sorama B.V.

export class DateExtensions {
    // See: http://stackoverflow.com/questions/11526504/minimum-and-maximum-date
    public static get MinDate(): Date {
        return new Date(-8640000000000000);
    }
    public static get MaxDate(): Date {
        return new Date(8640000000000000);
    }
}
